// extracted by mini-css-extract-plugin
export default {"container":"TK-z","timeTop":"UK-z","timeCountdown":"VK-z","cta":"WK-z","disabled":"XK-z","product":"YK-z"};